import { Provider } from "@angular/core";
import * as services from "./services";

export function providePersonnel(): Array<Provider>
{
    return [
        services.EmployeeESSUserLookupService,
        services.EmployeeManagerService,
        services.EmployeePayHistoryService,
        services.EmployeePhotoService,
        services.EmployeeRetirementService,
        services.EmployeeSearchService,
        services.EmployeeStatusLookupService,
        services.EmployeeTasksManagerService,
        services.HRDepartmentLookupService,
        services.JobTitleLookupService,
        services.PersonnelActionRequestService,
        services.PositionService,
        services.TerminationCodeLookupService,
        services.WorksiteLookupService,
    ];
}
